// extracted by css-extract-rspack-plugin
export default {"moderationNotesContainer":"moderationNotesContainer__ox1bq","moderationHeader":"moderationHeader__cc9z0","moderationText":"moderationText__RysJs"};